import { createSelector, createFeatureSelector } from '@ngrx/store';
import { ConfigState} from './config.reducer';


export const getConfigState = createFeatureSelector<ConfigState>('config');

export const getConfig = createSelector(getConfigState, (state =>  state ));
